import { ClipboardList, ArrowUpRight } from 'lucide-react';
import { QUESTIONNAIRE_URL } from '../../lib/site';

export const COMRA_BLURB = 'The Color of Money Risk Analysis: a short, interactive questionnaire that looks at your financial picture and gives you a Color of Money score and a roadmap to your risk preferences.';

export const QuestionnaireButton = ({ testid, showBlurb = true }) => (
  <div className="space-y-3 max-w-md">
    <a href={QUESTIONNAIRE_URL} target="_blank" rel="noopener" data-testid={testid}
      className="inline-flex items-center justify-center gap-2 rounded-full bg-white text-[#060A17] hover:bg-orange-100 px-7 py-4 font-semibold tracking-[0.15em] hover:-translate-y-0.5 shadow-[0_10px_30px_-10px_rgba(255,255,255,0.5)]">
      <ClipboardList className="w-5 h-5 text-orange-500" />
      COMRA
      <ArrowUpRight className="w-4 h-4" />
    </a>
    {showBlurb && <p data-testid={`${testid}-blurb`} className="text-sm text-slate-300 leading-relaxed">{COMRA_BLURB}</p>}
  </div>
);

const STEPS = [
  ['01', 'Take the COMRA', 'A short, interactive analysis of your financial picture.'],
  ['02', 'Get your score', 'See your Color of Money score and a roadmap to your risk preferences.'],
  ['03', 'Book your consultation', 'When you finish, pick a time on our retirement calendar.'],
];

export const QuestionnaireBanner = ({ testid }) => (
  <section data-testid={testid} className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
    <div className="glass-panel rounded-[2rem] p-8 md:p-12 border-orange-400/30 grid lg:grid-cols-12 gap-10 items-center">
      <div className="lg:col-span-5 space-y-5">
        <p className="text-xs uppercase tracking-[0.3em] text-orange-400 font-semibold">First step to retirement</p>
        <h2 className="font-display text-3xl md:text-4xl font-bold text-white tracking-tight">Color of Money Risk Analysis</h2>
        <QuestionnaireButton testid={`${testid}-button`} />
      </div>
      <ol className="lg:col-span-7 grid sm:grid-cols-3 gap-4">
        {STEPS.map(([n, title, copy]) => (
          <li key={n} className="rounded-2xl bg-white/[0.03] border border-white/10 p-5">
            <span className="font-serif-accent italic text-4xl text-orange-400/70">{n}</span>
            <p className="text-white font-semibold mt-3 mb-1">{title}</p>
            <p className="text-sm text-slate-400">{copy}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);
